
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M12.81 21h-1.483v-1.306C8.012 19.506 6.011 17.855 6 15.306h3.03c.073 1.035.974 1.808 2.297 1.944v-3.887l-1.112-.26c-2.542-.586-3.908-2.028-3.908-4.211 0-2.57 1.864-4.22 5.02-4.471V3h1.483v1.42c2.945.272 4.851 1.975 4.893 4.388h-2.955c-.031-.95-.826-1.734-1.938-1.89v3.719l1.134.23C16.665 11.44 18 12.83 18 15.087c0 2.664-1.875 4.315-5.19 4.586V21zm2.182-5.558c0-.96-.699-1.546-2.182-1.818v3.636c1.377-.084 2.182-.763 2.182-1.818zM9.38 8.6c0 .877.667 1.483 1.948 1.734V6.907C10.184 6.97 9.38 7.67 9.38 8.6z"}})])])
          )
        }
      }
    